/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Reconnect_RequiredInputs */

const fr_api_drive_reconnect_required = /** @type {(inputs: Api_Drive_Reconnect_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’autorisation Drive n’est plus valide. Reconnectez Google Drive.`)
};

const en_api_drive_reconnect_required = /** @type {(inputs: Api_Drive_Reconnect_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive authorization is no longer valid. Reconnect Google Drive.`)
};

/**
* | output |
* | --- |
* | "Drive authorization is no longer valid. Reconnect Google Drive." |
*
* @param {Api_Drive_Reconnect_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_reconnect_required = /** @type {((inputs?: Api_Drive_Reconnect_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Reconnect_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_reconnect_required(inputs)
	return fr_api_drive_reconnect_required(inputs)
});